import { get, post } from "../../service/api";

const GetMerchantData = async (id) => {
  try {
    const response = await get(`/merchant/${id}`);
    if (response) return response.data;
    return null;
  } catch (error) {
    console.error("Error GetMerchantData:", error);
    return null;
  }
};

export default GetMerchantData;
